<template>
  <div class="tw:w-full tw:flex tw:justify-center">
    <div class="tw-card tw:mx-3 tw:flex" :class="{'tw:border-t-primary-sicura': isSicuraSolution, 'tw:border-t-primary-light': !isSicuraSolution }" style="border-top-width: 6px; width: min(800px, 100%)">
      <div class="tw:w-16 tw:h-16 tw:rounded-full  tw:flex tw:justify-center tw:items-center" :class="{'tw:bg-primary-sicura/10': isSicuraSolution, 'tw:bg-primary-light/10': !isSicuraSolution }">
        <i class="fas fa-search " :class="{'tw:text-primary-sicura': isSicuraSolution, 'tw:text-primary-dark': !isSicuraSolution }" style="font-size: 24px" />
      </div>
      <div class="tw:flex tw:flex-col tw:justify-between tw:ml-4">
        <p class="tw:text-xl">
          {{ title || "Nessun risultato trovato" }}
        </p>
        <p class="tw:mb-1">
          {{ text || "Prova a modificare i criteri di ricerca" }}
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { useBrand } from '@/composables/useBrand';
import { defineComponent } from 'vue';

export default defineComponent({

  props: {
    title: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
  },

  setup() {
    const { isSicuraSolution } = useBrand();

    return {
      isSicuraSolution,
    };
  },
});
</script>
<style scoped></style>
